import { SET_ANALYTICS } from "./action-types";

// eslint-disable-next-line import/prefer-default-export
export function setAnalytics(type: string) {
  return {
    type: SET_ANALYTICS,
    payload: { type },
  };
}
